import React from 'react';
import PageWrapper from '../components/ui/PageWrapper';
import Hero from '../components/sections/Hero';
import ServicesGrid from '../components/sections/ServicesGrid';
import AboutFounder from '../components/sections/AboutFounder';
import ProcessTimeline from '../components/sections/ProcessTimeline';
import Testimonials from '../components/sections/Testimonials';
import CTASection from '../components/sections/CTASection';

export default function Home() {
  return (
    <PageWrapper>
      <Hero />
      <ServicesGrid />
      <AboutFounder />
      <ProcessTimeline />
      <Testimonials />
      <CTASection />
    </PageWrapper>
  );
}
